import { createElementVNode as _createElementVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { class: "c-sec u-bg02 no-style-ranking" }
const _hoisted_2 = /*#__PURE__*/_createElementVNode("h2", { class: "c-sec__title" }, "講座ランキング", -1)
const _hoisted_3 = { class: "l-inner" }
const _hoisted_4 = { class: "c-tab-control j-tab-ui" }
const _hoisted_5 = {
  class: "c-tab",
  role: "tablist",
  "aria-label": "ランキング"
}
const _hoisted_6 = ["aria-selected", "tabindex", "onClick"]
const _hoisted_7 = {
  class: "c-tab__right",
  role: "none presentation"
}
const _hoisted_8 = /*#__PURE__*/_createElementVNode("svg", {
  width: "20",
  height: "20"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-cup" })
], -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("span", null, "ランキングをもっと見る", -1)
const _hoisted_10 = { class: "c-tab-body" }
const _hoisted_11 = {
  id: "panel-panel-cont1",
  class: "c-tab-panel j-tabpanel",
  role: "tabpanel",
  "aria-labelledby": "tab-panel-cont1",
  "aria-hidden": "false"
}
const _hoisted_12 = { class: "p-rank-list is-home" }
const _hoisted_13 = { class: "c-item__thumb" }
const _hoisted_14 = ["src"]
const _hoisted_15 = { class: "c-item__time" }
const _hoisted_16 = { class: "c-item__header" }
const _hoisted_17 = { class: "c-item__title" }
const _hoisted_18 = { class: "c-item__like" }
const _hoisted_19 = /*#__PURE__*/_createElementVNode("svg", {
  width: "22",
  height: "22"
}, [
  /*#__PURE__*/_createElementVNode("use", { href: "#icon-like" })
], -1)
const _hoisted_20 = { class: "c-tags" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_router_link = _resolveComponent("router-link")!

  return (_openBlock(), _createElementBlock("section", _hoisted_1, [
    _hoisted_2,
    _createElementVNode("div", _hoisted_3, [
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("ul", _hoisted_5, [
          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.tabList, (tab, i) => {
            return (_openBlock(), _createElementBlock("li", {
              key: i,
              class: "c-tab__item",
              role: "none presentation"
            }, [
              _createElementVNode("button", {
                type: "button",
                class: "c-tab__btn j-tab",
                role: "tab",
                "aria-selected": _ctx.selectedTab == i,
                tabindex: (_ctx.selectedTab == i) ? 0: -1,
                onClick: ($event: any) => (_ctx.changeTab(i))
              }, _toDisplayString(tab.label), 9, _hoisted_6)
            ]))
          }), 128)),
          _createElementVNode("li", _hoisted_7, [
            _createVNode(_component_router_link, {
              to: { path: `/ranking` },
              class: "c-rank-all"
            }, {
              default: _withCtx(() => [
                _hoisted_8,
                _hoisted_9
              ]),
              _: 1
            })
          ])
        ]),
        _createElementVNode("div", _hoisted_10, [
          _createElementVNode("div", _hoisted_11, [
            _createElementVNode("div", _hoisted_12, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.listCourses(), (c) => {
                return (_openBlock(), _createElementBlock("div", {
                  key: c.id,
                  class: "c-item"
                }, [
                  _createElementVNode("div", _hoisted_13, [
                    _createVNode(_component_router_link, {
                      to: { path: `/course/${c.id}` }
                    }, {
                      default: _withCtx(() => [
                        _createElementVNode("picture", null, [
                          _createElementVNode("img", {
                            src: c.thumbnail,
                            width: "480",
                            height: "270",
                            alt: ""
                          }, null, 8, _hoisted_14)
                        ]),
                        _createElementVNode("span", _hoisted_15, _toDisplayString(_ctx.formatSec(c.duration)), 1)
                      ]),
                      _: 2
                    }, 1032, ["to"])
                  ]),
                  _createElementVNode("div", _hoisted_16, [
                    _createElementVNode("h3", _hoisted_17, [
                      _createVNode(_component_router_link, {
                        to: { path: `/course/${c.id}` }
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode(_toDisplayString(c.title), 1)
                        ]),
                        _: 2
                      }, 1032, ["to"])
                    ]),
                    _createElementVNode("div", _hoisted_18, [
                      _hoisted_19,
                      _createElementVNode("span", null, _toDisplayString(c.likes ? c.likes.count: 0), 1)
                    ])
                  ]),
                  _createElementVNode("ul", _hoisted_20, [
                    (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(c.tags.items, (tag, idx) => {
                      return (_openBlock(), _createElementBlock("li", { key: idx }, [
                        _createVNode(_component_router_link, {
                          to: { path: `/tag/${tag.tag.type}/${tag.tag.id}` }
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode(_toDisplayString(tag.tag.label), 1)
                          ]),
                          _: 2
                        }, 1032, ["to"])
                      ]))
                    }), 128))
                  ])
                ]))
              }), 128))
            ])
          ])
        ])
      ])
    ])
  ]))
}